import React, { useEffect, useState, useMemo } from "react";
import { Helmet } from "react-helmet";
import { apiUrl } from '../constants'
import axios from 'axios'
import CardPhoto from '../components/card/CardPhotoToUseLocation';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import chickenKoratImg from "../assets/img/chickenKorat.jpg"
import { useSelector } from 'react-redux';
import useCheckToken from '../hooks/useCheckToken';
import useExchangeToken from "../hooks/useExchangeToken";
import { useParams } from 'react-router-dom';
import Vietnam from '../assets/img/vietnam.jpg';

const CardPhotoMemo = React.memo(CardPhoto);

const FactoryList = () => {
  const { bu, plant } = useParams();
  const exchangeToken = useExchangeToken();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [factory, setFactory] = useState([]);
  const [isTokenExchanged, setIsTokenExchanged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useCheckToken();
  const ac_token = useSelector(state => state.auth.access_token);
  const factory_store = useSelector((state) => state.auth.factory);

  function storeCourse(name) {
    localStorage.setItem('factory', name)
  }

  useEffect(() => {
    const fetchInitialTokenAndData = async () => {
      try {
        const token = await exchangeToken(); 
        if (token) {
          setIsTokenExchanged(true);
        }
      } catch (err) {
        console.error("Error exchanging token:", err);
        setError("Failed to exchange token");
      }
    };

    fetchInitialTokenAndData();
  }, [exchangeToken]);


  useEffect(() => {
    const fetchMyAPI = async () => {
      if (!ac_token) return;
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl.MASTER_PLANT}${bu}/${plant}`, {
          headers: {
            Authorization: `Bearer ${ac_token}`,
          },
        });

        if (response.status === 200) {
          setFactory(response.data.FACTORY || [])
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching Plant data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (isTokenExchanged && ac_token) {
      fetchMyAPI(); // เรียก API เมื่อโทเค็นพร้อม
    }
  }, [isTokenExchanged, ac_token]);

  factory.sort((a, b) => {
    if (a.length !== b.length) {
      return a.length - b.length;
    }
    return a.localeCompare(b);
  });


  // const filterBUData = (factory_store, factory_from_api) => {
  //   if (factory_store === "All") {
  //     return factory_from_api; // แสดงผลทั้งหมดถ้า bu_store เป็น 'all'
  //   } else if (factory_store === "FPP2") {
  //     return factory_from_api;
  //   } else if (factory_store === "None") {
  //     return factory_from_api;
  //   } else if (factory_store === "-") {
  //     return factory_from_api;
  //   }
  //   return factory_from_api.filter((item) => item === factory_store); // กรองเฉพาะ BU ที่ตรงกับ bu_store
  // };

  const filterBUData = (factory_store, factory_from_api = []) => {
    const value = (factory_store ?? "").trim().toLowerCase();

    if (
      value === "all" ||
      value === "fpp2" ||
      value === "none" ||
      value === "-"
    ) {
      return factory_from_api;
    }

    return factory_from_api.filter(
      (item) => String(item).toLowerCase() === value
    );
  };

  const imageMap = {
    "4117": chickenKoratImg,
    "B425": Vietnam,
  };
  
  const getImageByPlant = (name) => imageMap[name] ?? chickenKoratImg;
  
  const factoryData = useMemo(() => {
    const filteredBu = filterBUData(factory_store, factory);
    return filteredBu.length === 0
      ? []
      : filteredBu.map((name, index) => ({
          key: index,
          name,
          fileLocation: getImageByPlant(plant),  
        }));
  }, [factory, factory_store, plant]);
  




  return (
    <Box style={{ width: "100%", height: "90vh" }}>
      <Helmet>
        <title>Factory | MES</title>
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Box
            m='1%'
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="100%"
            columnGap="1%"
            rowGap="6%"
          >
            {/* ESTIMATED */}
            {factoryData.map((item) => (
              <Box
                key={item.key || item.id}
                gridColumn="span 2"
                display="flex"
                alignItems="center"
                justifyContent="center"
                onClick={() => storeCourse(item.name)}
              >
                <CardPhotoMemo name={item.name} fileLocation={item.fileLocation || chickenKoratImg} />
              </Box>
            ))
            }
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default FactoryList
